import React from 'react';
import { motion } from 'framer-motion';
import CTAButton from './CTAButton';
const scrollToPricing = () => {
  const pricingSection = document.getElementById('pricing');
  if (pricingSection) {
    pricingSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
};
const Hero: React.FC = () => {
  return <section className="w-full bg-background py-16 md:py-20" data-id="element-86">
      <div className="container mx-auto px-4 md:px-8" data-id="element-87">
        <div className="flex flex-col md:flex-row items-center" data-id="element-88">
          <div className="w-full md:w-1/2 mb-10 md:mb-0" data-id="element-89">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-90">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-secondary mb-6" data-id="element-91">
                <span className="font-serif" data-id="element-92">Reto</span>{' '}
                <span className="text-5xl md:text-6xl lg:text-7xl font-bold text-secondary" data-id="element-93">
                  21
                </span>{' '}
                <span className="font-serif" data-id="element-94">DiAS</span> <br data-id="element-95" />
                <span className="text-primary text-5xl md:text-6xl lg:text-7xl font-bold font-serif" data-id="element-96">
                  SIN AZÚCAR
                </span>
              </h1>
              <h2 className="text-xl md:text-2xl font-medium mb-6" data-id="element-97">
                En solo 21 días verás cambios visibles en tu cuerpo
              </h2>
              <div className="flex flex-col gap-2 mb-8" data-id="element-98">
                <p className="text-lg" data-id="element-99">
                  <span className="text-primary font-medium" data-id="element-100">✓</span> Menos
                  hinchazón.
                </p>
                <p className="text-lg" data-id="element-101">
                  <span className="text-primary font-medium" data-id="element-102">✓</span> Menos
                  antojos.
                </p>
                <p className="text-lg" data-id="element-103">
                  <span className="text-primary font-medium" data-id="element-104">✓</span> Más
                  energía.
                </p>
                <p className="text-lg" data-id="element-105">
                  <span className="text-primary font-medium" data-id="element-106">✓</span> Más
                  autoestima.
                </p>
              </div>
              <p className="text-lg mb-8" data-id="element-107">
                El plan realista y delicioso para liberarte del azúcar{' '}
                <strong data-id="element-108">SIN dietas imposibles, SIN culpa, SIN sufrir.</strong>
              </p>
              <div className="mb-8" data-id="element-109">
                <CTAButton onClick={scrollToPricing} data-id="element-110">QUIERO MI RESET</CTAButton>
              </div>
            </motion.div>
          </div>
          <div className="w-full md:w-1/2" data-id="element-111">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="rounded-2xl overflow-hidden shadow-xl" data-id="element-112">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7iTN5YYJaRv8cftFA7wC4L/ChatGPT_Image_24_nov_2025%2C_14_42_55.png" alt="Reto 21 Días Sin Azúcar" className="w-full h-auto" data-id="element-113" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
};
export default Hero;